run.$inject = ['$rootScope','$templateCache','$state','$stateParams','$timeout','MenuConstant','courseFront'];

//funcion donde se definen la run

export default function run($rootScope,$templateCache,$state,$stateParams,$timeout,MenuConstant,courseFront) {
                MenuConstant[0]['menu'].push(courseFront);
}


// WEBPACK FOOTER //
// ./src/app/course-front/courseFront.run.js